import React, { Component } from 'react';
import { Button, Card, Table } from 'react-bootstrap'
import axios from 'axios'
import { connect } from 'react-redux';

class AdminFilament extends Component {
    state = {
        filamentsFormatted: []
    }
    componentDidMount() {

        axios.get('/api/filament/get-all').then((resp) => {
            let filamentsFormatted = this.state.filamentsFormatted
            resp.data.filaments.forEach(filament => {
                filamentsFormatted.push({ 'pricePerGram': filament.pricePerGram, 'name': filament.name, 'type': filament.type, 'stockInGrams': filament.stockInGrams, '_id': filament._id , gcodeOptions: JSON.stringify(filament.gcodeOptions)})
            })
            filamentsFormatted.push({ 'pricePerGram': '', 'name': '', 'type': '', 'stockInGrams': '', gcodeOptions: "" })
            this.setState({ filamentsFormatted: filamentsFormatted })
        })

    }

    updateFilament = (index) => {
        axios.post('/api/filament/set', this.state.filamentsFormatted[index]).then((res) => {
        })

    }

    updateInputF = (e, type, index) => {
        let filamentsFormatted = this.state.filamentsFormatted
        filamentsFormatted[index][type] = e.target.value
        this.setState({ 'filamentsFormatted': filamentsFormatted })
    }
    render() {
        let filaments = []
        this.state.filamentsFormatted.forEach((filament, index) => {
            filaments.push(
                <tr key={filament._id ? filament._id : "0"}>
                    <td onChange={(e) => this.updateInputF(e, 'pricePerGram', index)}><input type="number" placeholder={filament.pricePerGram} /></td>
                    <td onChange={(e) => this.updateInputF(e, 'name', index)}><input placeholder={filament.name}></input></td>
                    <td onChange={(e) => this.updateInputF(e, 'type', index)}><input placeholder={filament.type}></input></td>
                    <td onChange={(e) => this.updateInputF(e, 'stockInGrams', index)}><input type="number" placeholder={filament.stockInGrams}></input></td>
                    <td onChange={(e) => this.updateInputF(e, 'gcodeOptions', index)}><input  value={filament.gcodeOptions}></input></td>
                    <td>
                        <Button type='submit' onClick={() => this.updateFilament(index)}>
                            Update
                        </Button>
                    </td>
                </tr>
            )
        })
        let darkmode = this.props.user ? this.props.user.darkmode : true

        return (
            <Card style={{ margin: '30px' }}>
                <Card.Header  className={darkmode ? "darkmode-card-header" : "lightmode-card-header"}  style={{ textAlign: 'center' }}>
                    Filament
                </Card.Header>
                <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} >
                    <Table style={{ 'margin': '0px' }} bordered>
                        <thead>
                            <tr className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} >
                                <th>pricePerGram</th>
                                <th>name</th>
                                <th>type</th>
                                <th>stockInGrams</th>
                                <th>gcodeOptions</th>
                                <th>Update</th>
                            </tr>
                        </thead>
                        <tbody className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} >
                            {filaments}
                        </tbody>
                    </Table>
                    </Card.Body>
      
            </Card>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminFilament);